module.exports = __webpack_public_path__ + "media/person-description.ddaeb89a.mp4";